<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m6.813 7.952-.145-1.424a1 1 0 0 1 .893-1.1l13.474-1.375a1 1 0 0 1 1.1.894l.849 8.3a1 1 0 0 1-.89 1.1l-13.475 1.41a1 1 0 0 1-1.1-.894l-.34-3.03M14.254 10.761l5.848-.598M17.401 7.39l2.041-.209"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.012 10.517h1.714a3.86 3.86 0 0 1 1.645-2.17c.362-.189.75-.322 1.15-.395h4.216a1.477 1.477 0 0 1 0 2.953H7.556l-.031.117a3.16 3.16 0 0 1-3.4 2.322M1.085 18.267h2.206a3.85 3.85 0 0 0 3.158 1.685h7.317c.685 0 1.347-.249 1.863-.7.413-.36.713-.831.864-1.358l.2-.712"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
